import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOfferinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			fill: "currentColor",
			cx: 18,
			cy: 6,
			r: 2
		}), /* @__PURE__ */ _jsx("path", {
			d: "M22.414 9.729L9.85 22.293a1 1 0 0 1-1.414 0l-6.729-6.729a1 1 0 0 1 0-1.414L14.271 1.586A2 2 0 0 1 15.686 1H21a2 2 0 0 1 2 2v5.314a2 2 0 0 1-.586 1.415z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgOfferinline;
